module.exports = __webpack_public_path__ + "static/media/Item 22.176b48e7.jpg";